module.exports = __webpack_public_path__ + "static/img/ent-95.7804f89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-95.jpg
// module id = M6Tt
// module chunks = 51